import { AssetClassEvent } from './asset-class.event';
import { EventRegistry } from '../../../../../domain/event/event.registry';
export class AssetClassCreatedEvent extends AssetClassEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.id}`,
            type: AssetClassCreatedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
AssetClassCreatedEvent.type = 'com.treeplotter.api.asset-class.created.v1';
EventRegistry.register(AssetClassCreatedEvent.type, AssetClassCreatedEvent);
//# sourceMappingURL=asset-class-created.event.js.map